<!--診間掛號條件設定-->
<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <v-flex xs12>
        <v-card class="cardBgColorStyle">


            <v-card row wrap dark  color="secondary"  dense style="padding:0px 0px">

                <v-flex  d-inline-flex style="margin-bottom: -5px">
                    <v-btn @click="addItem"  dark fab top right color="accent" class="mb-2 mt-0">
                        <v-icon >mdi-plus</v-icon>
                    </v-btn>
                </v-flex>

                <!--程式名稱-->
                <v-flex d-inline-flex pl-2 style="font-size: 1.2rem;vertical-align: middle;margin-bottom: 15px;">
                    <!--<span>{{this.menuInfo.funTitle}} 掛號說明維護</span>-->
                    <span> 診間/醫師/科別掛號條件設定</span>
                </v-flex>

                <v-flex class="d-inline-flex pl-2 xs12 sm12 md12"   style="margin-bottom: -10px">


                    <v-select
                            v-if="zoneNameList.length>0"
                            dark
                            @change="axios_getClinicChk (zone)"
                            v-model="zone"
                            hide-details
                            :items="zoneNameList"
                            :item-text="zoneItemText"
                            item-value="zone"
                            label="院區代號"
                    ></v-select>

                    <v-text-field
                            v-else
                            v-model="zone"
                            label="院區代號"
                            @keyup.enter="axios_getClinicChk (zone)"
                    ></v-text-field>

                    <v-btn  dark  class="regFRBtn mt-2 ml-2"  @click="axios_getClinicChk(zone)">
                        查詢
                    </v-btn>

                    <!--<v-btn mt-2 color="primary"  @click="">查詢</v-btn>-->


                </v-flex>





            </v-card>


            <v-flex style="padding-top: 1rem">
                <v-data-table
                        dense
                        id="sysSetTable"
                        @page-count="pagination.pageCount = $event"
                        :page.sync="pagination.page"
                        :sort-by="pagination.sortBy"
                        :sort-desc="pagination.descending"
                        :loading-text="loadingText"
                        :loading="sysSetLoading"
                        :headers="sysSetHeaders"
                        :items="sysSetList"
                        :search="search"
                        :items-per-page="pagination.rowsPerPage"
                        hide-default-footer
                        hide-default-header
                        item-key="chart_no"
                        v-resize="resizeSysSetListGrid"
                        class="elevation-1">

                    <template v-slot:header="{ props }">
                        <tr class="px-1 text-left tablehead">
                            <th v-for="header in props.headers"
                                :key="header.text"
                                :class="['column sortable',pagination.descending ? 'desc' : 'asc', header.value === pagination.sortBy ? 'active' : '','px-1']"
                                @click="changeSort(header.value)">
                                <span  v-html="header.text"></span>
                                <v-icon small
                                        :style="{display:header.value === pagination.sortBy ? pagination.descending ? 'none' : 'inline' : 'none'}">
                                    mdi-arrow-up
                                </v-icon>
                                <v-icon small
                                        :style="{display:header.value === pagination.sortBy ? pagination.descending ? 'inline' : 'none' : 'none'}">
                                    mdi-arrow-down
                                </v-icon>
                            </th>
                        </tr>
                    </template>

                    <template slot="item" slot-scope="props" style="border: 1px solid black">
                        <!--<tr :active="props.selected" @click="props.selected = !props.selected">-->
                        <!--<td>
                          <v-checkbox :input-value="props.selected" primary hide-details></v-checkbox>
                        </td>-->
                        <tr>
                            <td class=" align-space-around justify-space-around fill-height px-0" >
                                <v-layout>
                                    <v-btn  icon class="mx-0" @click.native.stop="editItem(props.item)">
                                        <v-icon color="tertiary">mdi-pencil</v-icon>
                                    </v-btn>
                                    <v-btn   icon class="mx-0" @click.native.stop="deleteItem(props.item)">
                                        <v-icon color="tertiary">mdi-delete</v-icon>
                                    </v-btn>
                                </v-layout>
                            </td>
                            <td  class="px-1 text-left">{{ props.item.zone}}</td>
                            <td  class="px-1 text-left">{{ props.item.judgeType}}</td>
                            <td  class="px-1 text-left">{{ props.item.clinicNo}}</td>
                            <td  class="px-1 text-left">{{ props.item.chkOrder}}</td>
                            <td  class="px-1 text-left">{{ props.item.chkType}}</td>
                            <td  class="px-1 text-left">{{ props.item.valType}}</td>
                            <td  class="px-1 text-left">{{ props.item.oper}}</td>
                            <td  class="px-1 text-left">{{ props.item.val1}}</td>
                            <td  class="px-1 text-left">{{ props.item.val2}}</td>
                            <td  class="px-1 text-left" v-html="props.item.promptNote" style="white-space: pre-line;"></td>
                            <td  class="px-1 text-left">{{ props.item.effFlag}}</td>


                        </tr>
                    </template>
                    <template slot="pageText" slot-scope="props">
                        第 {{ props.pageStart }} - {{ props.pageStop }} ,共 {{ props.itemsLength }} 筆
                    </template>
                    <template slot="no-data">
                        <v-alert :value='countDownNo>=5' type="warning" icon="mdi-alert-circle">
                            查詢中...
                        </v-alert>
                        <v-alert :value='tableAlert' color="info" icon="mdi-information">
                            表格中沒有內容
                        </v-alert>
                    </template>
                    <!--<v-alert slot="no-results" :value="true" color="info" icon="mdi-alert-circle">-->
                    <!--Your search for " {{ search }} " found no results.-->
                    <!--</v-alert>-->
                </v-data-table>
                <v-layout row wrap>
                    <v-flex xs12 md2>
                        <v-text-field
                                v-model="search"
                                class="ml-2 mt-2"
                                prepend-inner-icon="mdi-magnify"
                                single-line
                                hide-details
                                clearable
                        ></v-text-field>
                    </v-flex>
                    <v-flex xs12 md6 text-center pt-2>
                        <v-pagination color="accent" v-model="pagination.page" :length="pagination.pageCount" :total-visible="7"></v-pagination>
                    </v-flex>
                    <v-flex xs6 md2 pt-2 pr-2 pl-2>
                        <v-select
                                :items="pageItem"
                                label="每頁筆數"
                                item-value="value"
                                v-model="pagination.rowsPerPage"
                        ></v-select>
                    </v-flex>
                    <v-flex xs6 md2 text-left pt-2 pr-2>
                        <v-text-field
                                label="總筆數"
                                v-model="sysSetList.length"
                                readonly
                        ></v-text-field>
                    </v-flex>
                </v-layout>
            </v-flex>


        </v-card>

        <v-dialog v-model="editDialog"
                  eager
                  persistent
                  xs6 sm6 md6
                  :width="editDialogWidth+'%'"
                  value="false"
                  scrollable>
            <edit-clinic-chk :zone-name-list="zoneNameList" :is-show="editDialog" @closeDialog="closeDialog" @save="save" :edit-index="editIndex" :edit-obj="editObj"></edit-clinic-chk>
        </v-dialog>

        <v-dialog v-model="deleteDialog"
                  width="50%"
                  persistent
                  xs6 sm6 md6
                  value="false"
                  scrollable>
            <delete-info-dialog @closeDelete="closeDelete" @confirmDelete="confirmDelete" :delete-title="deleteTitle" :delete-content="deleteContent"></delete-info-dialog>
        </v-dialog>

        <!-- 我是 snackbar -->
        <v-snackbar
                :timeout="snTimeout"
                v-model="snStatus">
            {{snText}}
        </v-snackbar>


    </v-flex>
</template>

<script>
    import EditClinicChk from './EditClinicChk'
    import DeleteInfoDialog from '../inursingsys/DeleteInfoDialog'
    export default {
        name: "ClinicChkMaintain",
        components:{DeleteInfoDialog,EditClinicChk},
        data() {
            return {
                zoneNameList:[],
                countDownId: null, //data 定義一個定時器id
                countDownNo:0,
                sysSetLoading:false,
                loadingText:'查詢中...',
                tableAlert:false,
                search:'',
                snTimeout:4000,
                snStatus:false,
                snText:'',
                deleteDialog:false,
                deleteTitle:'刪除 診間掛號條件設定',
                deleteContent:'',
                deleteObj:{},
                editDialog:false,
                editIndex:-1,
                editObj:{},
                sysSetList: [],
                viewDate:'',
                zone:'A',
                pagination: {
                    sortBy: 'dataType',
                    rowsPerPage:100,
                    page: 1,
                    pageCount: 0,
                    descending:false
                },
                pageItem:[
                    {text:100,value:100},
                    {text:20,value:20},
                    {text:"All",value:-1},
                ],
                pageText:'每頁筆數 :',
                sysSetHeaders:[
                    {
                        text: '',
                        align: 'center',
                        // value: 'assessDate'
                    },
                    {
                        text: '院區代號',
                        // align: 'center',
                        value: 'zone',
                        class:'px-1'
                    },
                    {
                        text: '判斷類別',
                        // align: 'center',
                        value: 'judgeType',
                        class:'px-1'
                    },
                    {
                        text: '診間/醫師/科別代號',
                        // align: 'center',
                        value: 'clinicNo',
                        class:'px-1'
                    },
                    {
                        text: '判斷序號',
                        // align: 'left',
                        value: 'chkOrder',
                        class:'px-1'
                    },
                    {
                        text: '檢查類別',
                        // align: 'left',
                        value: 'chkType',
                        class:'px-1'
                    },
                    {
                        text: '值型態',
                        // align: 'center',
                        value: 'valType',
                        class:'px-1'
                    },
                    {
                        text: '操作符號',
                        // align: 'center',
                        value: 'Oper',
                        class:'px-1'
                    },
                    {
                        text: '值1',
                        // align: 'center',
                        value: 'val1',
                        class:'px-1'
                    },
                    {
                        text: '值2',
                        // align: 'center',
                        value: 'val2',
                        class:'px-1'
                    },
                    {
                        text: '提示文字',
                        // align: 'center',
                        value: 'promptNote',
                        class:'px-1'
                    },
                    {
                        text: '有效否',
                        // align: 'center',
                        value: 'effFlag',
                        class:'px-1'
                    },
                ],
            }
        },
        created(){
            this.axios_getZoneNameALL();
            this.axios_getClinicChk('A');
        },
        computed:{
            menuInfo() {
                return this.$store.state.menuInfo;
            },
            editDialogWidth(){ //隨畫面大小 調整Dialog的寬度
                let width = 50;
                if (this.$vuetify.breakpoint.xs == true) {width = 100 }
                if(this.$vuetify.breakpoint.sm == true){width = 97}
                if(this.$vuetify.breakpoint.md == true){width =  60}
                if(this.$vuetify.breakpoint.lg == true){width =  70}
                if(this.$vuetify.breakpoint.xl ==true){width =  70}
                return width
            },
        },
        watch:{
        },
        methods:{
            zoneItemText: item => item.zone==''?'':item.zone + '-' + item.zoneName, //格式化 院區顯示文字
            transNoteEvent(noteFlag){
                let str='';
                if(noteFlag=='A'){
                    str = "掛號輸入畫面"
                }else if(noteFlag=='B'){
                    str = "掛號結果畫面"
                }else {
                    str = noteFlag;
                }
                return str;

            },
            countDown(){
                if(this.countDownId != null ) return;
                this.countDownId = setInterval(() => {
                    this.countDownNo++
                },1000)
            },
            //停止計時器
            stopCountDown(){
                clearInterval(this.countDownId);
                //當我清除定時器之後，重新讓intervalId為null
                this.countDownId = null;
                this.countDownNo=0;
            },
            changeSort: function(column) {
                // console.log(column);
                if (this.pagination.sortBy === column) {
                    this.pagination.descending = !this.pagination.descending
                } else {
                    this.pagination.sortBy = column;
                    this.pagination.descending = false
                }
            },
            closeDelete(){
                this.deleteDialog = false;

            },
            confirmDelete(){
                this.axios_deleteClinicChk(this.deleteObj);
            },
            addItem(){  //新增按鈕
                this.editDialog = true;
                this.editIndex = -1;
            },
            closeDialog(){ //關閉編輯視窗
                this.editDialog = false;
            },
            editItem:function(item){
                this.editIndex = this.sysSetList.indexOf(item);
                this.editObj = item;
                this.editDialog = true;
            },
            deleteItem:function(item){  //刪除
                this.deleteObj = item;
                this.deleteDialog = true;
                this.deleteContent = '確定要刪除，[院區代號 '+item.zone+" / 判斷類別 "+item.judgeType+ "/ 診間醫師科別代號 "+item.clinicNo+" / 判斷序號 "+item.chkOrder+"]記錄";
            },
            save(item){
                if(this.editIndex==-1){ //新增
                    this.axios_postClinicChk(item);
                }else { //修改
                    this.axios_putClinicChk(item);
                }
            },
            resizeSysSetListGrid:function(){
                var userHeight = window.innerHeight
                    || document.documentElement.clientHeight
                    || document.body.clientHeight;
                var height = userHeight-(275);
                var sysSetTable = document.getElementById('sysSetTable');
                sysSetTable.setAttribute('style','overflow-y: auto;min-height:'+height+'px;max-height:'+height+'px;');
            },
            axios_getClinicChk (zone){ //
                let url = '';
                if(zone!==''&&zone!==undefined){
                    this.countDown();
                    this.sysSetLoading = true;
                    this.tableAlert = false;
                    this.sysSetList = [];
                    url = this.$store.state.AppSetting.backSrvUrl + "clinicchk/datasearch/byzone/"+zone
                    this.$http.get(url).then(response =>{
                        if(response.data.status == 'INFO' && response.data.hasOwnProperty('resultSet') && response.data.resultSet.length>0){
                            this.sysSetList = response.data.resultSet;
                            this.sysSetLoading = false;
                            this.stopCountDown();
                        }else{
                            this.tableAlert = true;
                            this.sysSetList = [];
                            this.sysSetLoading = false;
                            this.stopCountDown();
                        }


                    }).catch(error =>  {
                        try {
                            console.log(error.response.data.status);
                            this.sysSetList = [];
                        } catch(err) {
                            this.sysSetLoading = false;
                        }
                        this.sysSetLoading = false;
                        this.stopCountDown();
                    });

                }else {
                    alert('請選擇院區代號');
                }
            },
            axios_postClinicChk(postData){ //新增
                let postList = [];
                postList.push(postData);
                let url = this.$store.state.AppSetting.backSrvUrl+'clinicchk/';

                this.$http.post(url,postList).then(response=>{
                    this.snStatus=true;
                    this.snText = response.data.message;
                    if(response.data.resultSet.length>0&& response.data.hasOwnProperty('resultSet')){
                        this.editDialog = false;
                        this.axios_getClinicChk(postData.zone)

                    }
                    this.snText = response.data.message;
                }).catch(error =>{
                    try{
                        this.snStatus=true;
                        this.snText = error.response.data.message;
                    }catch (e) {
                        this.snStatus=true;
                        this.snText = error.response.data.message;
                    }
                });
            },
            axios_putClinicChk(putData){ //修改
                let postList = [];
                postList.push(putData);
                let url = this.$store.state.AppSetting.backSrvUrl+'clinicchk/';

                this.$http.put(url,postList).then(response=>{
                    this.snStatus=true;
                    this.snText = response.data.message;
                    if(response.data.resultSet.length>0){
                        this.editDialog = false;
                        this.axios_getClinicChk(putData.zone)
                    }
                }).catch(error =>{
                    try{
                        this.snStatus=true;
                        this.snText = error.response.data.message;

                    }catch (e) {
                        this.snStatus=true;
                        this.snText = error.response.data.message;
                    }
                });
            },
            axios_deleteClinicChk(item){   //刪除單筆資料
                let url = this.$store.state.AppSetting.backSrvUrl+'clinicchk/s/'+item.zone+"/"+item.judgeType+"/"+item.clinicNo+"/"+item.chkOrder;

                this.$http.delete(url).then(response=>{
                    this.snStatus=true;
                    this.snText = response.data.message;
                    if(response.data.resultSet.length>0){
                        this.axios_getClinicChk(item.zone)
                        this.deleteDialog = false;
                    }

                }).catch(error =>{
                    try{
                        this.snStatus=true;
                        this.snText = error.response.data.message;

                    }catch (e) {
                        this.snStatus=true;
                        this.snText = error.response.data.message;
                    }
                });
            },
            axios_getZoneNameALL (){  //查詢院區名稱
                this.zoneNameList =[];
                let url = '';
                url = this.$store.state.AppSetting.backSrvUrl + "zoneset/datasearch/primarykeys/ALL";
                this.$http.get(url).then(response =>{
                    if(response.data.status == 'INFO' && response.data.hasOwnProperty('resultSet') && response.data.resultSet.length>0){
                        this.zoneNameList = response.data.resultSet;
                    }else{
                        this.zoneNameList =[];
                    }
                }).catch(error =>  {
                    this.zoneNameList =[];
                    try {
                        console.log(error.response.data.status);

                    } catch(err) {
                        console.log(err.toString())
                    }
                });
            },


        }
    }
</script>

<style scoped>

</style>